import { useI18n } from "../../i18n";
import React from "react";
import {
  faBriefcase,
  faCodePullRequest,
  faSchool,
} from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import styles from "./styles/custom-card.module.css";

const CustomCards = (props) => {
  const { t } = useI18n();
  // type = 'work' or 'education' or 'contribution'
  const { type = "work", arr = [] } = props;
  const icon =
    type === "work"
      ? faBriefcase
      : type === "education"
        ? faSchool
        : faCodePullRequest;
  const title = t(type);

  return (
    <div>
      <Card
        icon={icon}
        title={title}
        body={
          <div className={styles["custom-cards-body"]}>
            {arr.map((item) => (
              <div className={styles["custom-card"]} key={item.id}>
                <img
                  src={item.image}
                  alt={item.title}
                  className={styles["custom-card-image"]}
                />
                <div className={styles["custom-card-title"]}>{item.title}</div>
                <div className={styles["custom-card-subtitle"]}>
                  {item.subtitle}
                </div>
                <div className={styles["custom-card-duration"]}>
                  {item.duration}
                </div>
              </div>
            ))}
          </div>
        }
      />
    </div>
  );
};

export default CustomCards;
